import { injectStyles } from "./styles";
import { ModalScreen, ResultTab } from "./types";
import { getUploadInstructions, UploadInstructions } from "./instructions";
import logoUrl from "./assets/LogoWithPoweredBy.png";
import logoUrlDesktop from "./assets/LogoWithPoweredByDesktop.png";

/* ── SVG Icons ── */
const ICONS = {
  close: `<svg viewBox="0 0 20 20" fill="none"><path d="M15 5L5 15M5 5l10 10" stroke="black" stroke-width="2" stroke-linecap="round"/></svg>`,
  back: `<svg viewBox="0 0 20 20" fill="none"><path d="M12.5 15L7.5 10L12.5 5" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
  upload: `<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none"><path opacity="0.2" d="M10 20.1078L15.9906 14.1156C16.1067 13.9994 16.2446 13.9072 16.3963 13.8443C16.5481 13.7814 16.7107 13.749 16.875 13.749C17.0393 13.749 17.2019 13.7814 17.3537 13.8443C17.5054 13.9072 17.6433 13.9994 17.7594 14.1156L25.5172 21.875L29.5312 17.8656C29.7656 17.6314 30.0835 17.4998 30.4148 17.4998C30.7462 17.4998 31.064 17.6314 31.2984 17.8656L35 21.5719V8.75C35 8.41848 34.8683 8.10054 34.6339 7.86612C34.3995 7.6317 34.0815 7.5 33.75 7.5H11.25C10.9185 7.5 10.6005 7.6317 10.3661 7.86612C10.1317 8.10054 10 8.41848 10 8.75V20.1078Z" fill="black"/><path d="M33.75 7.5H11.25C10.5596 7.5 10 8.05964 10 8.75V26.25C10 26.9404 10.5596 27.5 11.25 27.5H33.75C34.4404 27.5 35 26.9404 35 26.25V8.75C35 8.05964 34.4404 7.5 33.75 7.5Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M26.875 15C27.9105 15 28.75 14.1605 28.75 13.125C28.75 12.0895 27.9105 11.25 26.875 11.25C25.8395 11.25 25 12.0895 25 13.125C25 14.1605 25.8395 15 26.875 15Z" fill="black"/><path d="M10 20.1078L15.9906 14.1156C16.1067 13.9994 16.2446 13.9072 16.3963 13.8443C16.5481 13.7814 16.7107 13.749 16.875 13.749C17.0393 13.749 17.2019 13.7814 17.3537 13.8443C17.5054 13.9072 17.6433 13.9994 17.7594 14.1156L25.5172 21.875L29.5312 17.8656C29.7656 17.6314 30.0835 17.4998 30.4148 17.4998C30.7462 17.4998 31.064 17.6314 31.2984 17.8656L35 21.5719" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M30 27.5V31.25C30 31.5815 29.8683 31.8995 29.6339 32.1339C29.3995 32.3683 29.0815 32.5 28.75 32.5H6.25C5.91848 32.5 5.60054 32.3683 5.36612 32.1339C5.1317 31.8995 5 31.5815 5 31.25V13.75C5 13.4185 5.1317 13.1005 5.36612 12.8661C5.60054 12.6317 5.91848 12.5 6.25 12.5H10" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
  gallery: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M14 9.00003V13C14 13.1326 13.9473 13.2598 13.8536 13.3536C13.7598 13.4473 13.6326 13.5 13.5 13.5H2.5C2.36739 13.5 2.24021 13.4473 2.14645 13.3536C2.05268 13.2598 2 13.1326 2 13V9.00003C2 8.86742 2.05268 8.74024 2.14645 8.64647C2.24021 8.55271 2.36739 8.50003 2.5 8.50003C2.63261 8.50003 2.75979 8.55271 2.85355 8.64647C2.94732 8.74024 3 8.86742 3 9.00003V12.5H13V9.00003C13 8.86742 13.0527 8.74024 13.1464 8.64647C13.2402 8.55271 13.3674 8.50003 13.5 8.50003C13.6326 8.50003 13.7598 8.55271 13.8536 8.64647C13.9473 8.74024 14 8.86742 14 9.00003ZM5.5 5.00003H7.5V9.00003C7.5 9.13264 7.55268 9.25981 7.64645 9.35358C7.74021 9.44735 7.86739 9.50003 8 9.50003C8.13261 9.50003 8.25979 9.44735 8.35355 9.35358C8.44732 9.25981 8.5 9.13264 8.5 9.00003V5.00003H10.5C10.5989 5.00011 10.6957 4.97082 10.778 4.91589C10.8603 4.86095 10.9244 4.78283 10.9623 4.69142C11.0002 4.60001 11.0101 4.49942 10.9908 4.40237C10.9714 4.30533 10.9238 4.2162 10.8538 4.14628L8.35375 1.64628C8.30731 1.59979 8.25217 1.56291 8.19147 1.53775C8.13077 1.51258 8.06571 1.49963 8 1.49963C7.93429 1.49963 7.86923 1.51258 7.80853 1.53775C7.74783 1.56291 7.69269 1.59979 7.64625 1.64628L5.14625 4.14628C5.07624 4.2162 5.02856 4.30533 5.00924 4.40237C4.98991 4.49942 4.99981 4.60001 5.03769 4.69142C5.07556 4.78283 5.13971 4.86095 5.22201 4.91589C5.30431 4.97082 5.40105 5.00011 5.5 5.00003Z" fill="white"/></svg>`,
  camera: `<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none"><path d="M20.3125 5.46875H17.6055L16.2744 3.47266C16.2031 3.36577 16.1065 3.27813 15.9933 3.21749C15.88 3.15684 15.7535 3.12508 15.625 3.125H9.375C9.24651 3.12508 9.12003 3.15684 9.00675 3.21749C8.89347 3.27813 8.7969 3.36577 8.72559 3.47266L7.39355 5.46875H4.6875C4.0659 5.46875 3.46976 5.71568 3.03022 6.15522C2.59068 6.59476 2.34375 7.1909 2.34375 7.8125V18.75C2.34375 19.3716 2.59068 19.9677 3.03022 20.4073C3.46976 20.8468 4.0659 21.0938 4.6875 21.0938H20.3125C20.9341 21.0938 21.5302 20.8468 21.9698 20.4073C22.4093 19.9677 22.6562 19.3716 22.6562 18.75V7.8125C22.6562 7.1909 22.4093 6.59476 21.9698 6.15522C21.5302 5.71568 20.9341 5.46875 20.3125 5.46875ZM16.0156 12.8906C16.0156 13.5859 15.8094 14.2657 15.4231 14.8438C15.0368 15.4219 14.4878 15.8725 13.8454 16.1386C13.203 16.4047 12.4961 16.4743 11.8141 16.3387C11.1322 16.203 10.5057 15.8682 10.0141 15.3765C9.52241 14.8849 9.18758 14.2585 9.05193 13.5765C8.91628 12.8945 8.9859 12.1876 9.25199 11.5453C9.51807 10.9029 9.96868 10.3538 10.5468 9.96749C11.125 9.58119 11.8047 9.375 12.5 9.375C13.4324 9.375 14.3266 9.7454 14.9859 10.4047C15.6452 11.064 16.0156 11.9582 16.0156 12.8906Z" fill="white"/></svg>`,
  info: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="10" stroke="#863AFF" stroke-width="2"/><path d="M12 16v-4M12 8h.01" stroke="#863AFF" stroke-width="2" stroke-linecap="round"/></svg>`,
  check: `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 16 16" fill="none"><path d="M13.3334 4L6.00008 11.3333L2.66675 8" stroke="#863AFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
  historyEmpty: `<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none"><path opacity="0.2" d="M32.5 6.25H7.5C7.16848 6.25 6.85054 6.3817 6.61612 6.61612C6.3817 6.85054 6.25 7.16848 6.25 7.5V32.5C6.25 32.8315 6.3817 33.1495 6.61612 33.3839C6.85054 33.6183 7.16848 33.75 7.5 33.75H8.85781L25.9906 16.6156C26.1067 16.4994 26.2446 16.4072 26.3963 16.3443C26.5481 16.2814 26.7107 16.249 26.875 16.249C27.0393 16.249 27.2019 16.2814 27.3537 16.3443C27.5054 16.4072 27.6433 16.4994 27.7594 14.1156L33.75 22.6078V7.5C33.75 7.16848 33.6183 6.85054 33.3839 6.61612C33.1495 6.3817 32.8315 6.25 32.5 6.25ZM15 17.5C14.5055 17.5 14.0222 17.3534 13.6111 17.0787C13.2 16.804 12.8795 16.4135 12.6903 15.9567C12.5011 15.4999 12.4516 14.9972 12.548 14.5123C12.6445 14.0273 12.8826 13.5819 13.2322 13.2322C13.5819 12.8826 14.0273 12.6445 14.5123 12.548C14.9972 12.4516 15.4999 12.5011 15.9567 12.6903C16.4135 12.8795 16.804 13.2 17.0787 13.6111C17.3534 14.0222 17.5 14.5055 17.5 15C17.5 15.663 17.2366 16.2989 16.7678 16.7678C16.2989 17.2366 15.663 17.5 15 17.5Z" fill="black"/><path d="M32.5 6.25H7.5C6.80964 6.25 6.25 6.80964 6.25 7.5V32.5C6.25 33.1904 6.80964 33.75 7.5 33.75H32.5C33.1904 33.75 33.75 33.1904 33.75 32.5V7.5C33.75 6.80964 33.1904 6.25 32.5 6.25Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M15 17.5C16.3807 17.5 17.5 16.3807 17.5 15C17.5 13.6193 16.3807 12.5 15 12.5C13.6193 12.5 12.5 13.6193 12.5 15C12.5 16.3807 13.6193 17.5 15 17.5Z" fill="black" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M8.85791 33.75L25.9907 16.6156C26.1068 16.4994 26.2447 16.4072 26.3964 16.3443C26.5482 16.2814 26.7108 16.249 26.8751 16.249C27.0394 16.249 27.202 16.2814 27.3538 16.3443C27.5055 16.4072 27.6434 16.4994 27.7595 16.6156L33.7501 22.6078" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
  spinner: `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none"><path d="M16 4V8" stroke="#79747E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M28 16H24" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M24.485 24.485L21.6562 21.6562" stroke="#79747E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M16 28V24" stroke="#79747E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M7.51465 24.485L10.3434 21.6562" stroke="#79747E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M4 16H8" stroke="#79747E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M7.51465 7.51501L10.3434 10.3438" stroke="#79747E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M24.8291 7.51501L22.0004 10.3438" stroke="#79747E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
  slider: `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M9 2.8125V15.1875" stroke="white" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/><path d="M6.75 9H1.125" stroke="white" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/><path d="M3.375 11.25L1.125 9L3.375 6.75" stroke="white" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/><path d="M11.25 9H16.875" stroke="white" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/><path d="M14.625 6.75L16.875 9L14.625 11.25" stroke="white" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
  retry: `<svg viewBox="0 0 16 16" fill="none"><path d="M1 2v5h5M15 14v-5h-5" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M13.49 6A6 6 0 002.46 4.84L1 7m14 2l-1.46 2.16A6 6 0 012.51 10" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
  cart: `<svg viewBox="0 0 16 16" fill="none"><path d="M1.5 1.5h2l1.5 8h7l1.5-6H5" stroke="white" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/><circle cx="6.5" cy="13" r="1" fill="white"/><circle cx="12.5" cy="13" r="1" fill="white"/></svg>`,
};

/* ── HTML escaping utility ── */
function escapeHtml(str: string | undefined | null): string {
  if (!str) return "";
  return str
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
}

/* ── Types for callbacks ── */
export interface ModalHandlers {
  onClose: () => void;
  onBrowseGallery: () => void;
  onTakePhoto: () => void;
  onTryOn: () => void;
  onChooseAnother: () => void;
  onRetry: () => void;
  onAddToCart: () => void;
  onHistoryItemClick: (resultUrl: string, originalUrl: string) => void;
  onViewAllHistory: () => void;
}

interface TryOnHistoryItem {
  resultUrl: string;
  originalPhotoUrl: string;
  productTitle: string;
  createdAt: string;
}

/**
 * Multi-screen modal manager matching the Figma designs.
 * Screens: upload → preview → loading → result
 */
export class ModalManager {
  private modal: HTMLElement | null = null;
  private handlers: ModalHandlers | null = null;
  private activeTab: ResultTab = "tryon";
  private sliderPosition = 50;
  private isDragging = false;

  // State data
  private shopDomain = "";
  private previewImageUrl = "";
  private originalPhotoUrl = "";
  private resultImageUrl = "";
  private isCurrentTryOn = false;
  private tryOnHistory: TryOnHistoryItem[] = [];
  private cleanupFunctions: Array<() => void> = [];

  /**
   * Creates the modal shell and shows the upload screen.
   */
  create(handlers: ModalHandlers, shopDomain?: string): void {
    this.handlers = handlers;
    this.shopDomain = shopDomain || "";
    injectStyles();

    this.modal = document.createElement("div");
    this.modal.id = "snapstyle-modal";
    this.modal.innerHTML = `<div class="snapstyle-modal-content"></div>`;

    document.body.appendChild(this.modal);
    document.body.classList.add("snapstyle-modal-open");

    // Close on backdrop click
    this.modal.addEventListener("click", (e) => {
      if (e.target === this.modal && this.handlers) {
        this.handlers.onClose();
      }
    });

    this.showScreen("upload");
  }

  destroy(): void {
    if (this.modal) {
      this.modal.remove();
      this.modal = null;
    }
    document.body.classList.remove("snapstyle-modal-open");
    this.cleanupFunctions.forEach((fn) => fn());
    this.cleanupFunctions = [];
    this.handlers = null;
    this.shopDomain = "";
    this.previewImageUrl = "";
    this.originalPhotoUrl = "";
    this.resultImageUrl = "";
    this.isCurrentTryOn = false;
    this.tryOnHistory = [];
    this.activeTab = "tryon";
  }

  setShopDomain(shopDomain: string): void {
    this.shopDomain = shopDomain;
  }

  getUploadInstructions(): UploadInstructions {
    const domain =
      this.shopDomain ||
      (typeof window !== "undefined" && window.location
        ? window.location.hostname
        : "");
    return getUploadInstructions(domain);
  }

  get isOpen(): boolean {
    return this.modal !== null;
  }

  /**
   * Shows a small inline error overlay on top of the current screen.
   * Has a message, optional retry button, and dismiss (×) button.
   */
  showErrorToast(message: string, onRetry?: () => void): void {
    // Remove any existing toast first
    this.modal?.querySelector(".snapstyle-error-toast")?.remove();

    const toast = document.createElement("div");
    toast.className = "snapstyle-error-toast";
    toast.innerHTML = `
      <div class="snapstyle-error-toast-card">
        <button class="snapstyle-error-toast-close">&times;</button>
        <div class="snapstyle-error-toast-icon">
          <svg viewBox="0 0 24 24" fill="none"><path d="M12 9v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" stroke="#DC2626" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
        </div>
        <p class="snapstyle-error-toast-msg">${escapeHtml(message)}</p>
        ${onRetry ? `<button class="snapstyle-error-toast-retry">Try again</button>` : ""}
      </div>
    `;

    // Wire events
    toast.querySelector(".snapstyle-error-toast-close")?.addEventListener("click", () => toast.remove());
    toast.addEventListener("click", (e) => { if (e.target === toast) toast.remove(); });
    if (onRetry) {
      toast.querySelector(".snapstyle-error-toast-retry")?.addEventListener("click", () => {
        toast.remove();
        onRetry();
      });
    }

    this.modal?.appendChild(toast);
  }

  /* ───────────────────────────────
     Screen Management
     ─────────────────────────────── */

  showScreen(screen: ModalScreen): void {
    const content = this.modal?.querySelector(".snapstyle-modal-content");
    if (!content) return;

    switch (screen) {
      case "upload":
        content.innerHTML = this.renderUploadScreen();
        this.wireUploadEvents();
        break;
      case "preview":
        content.innerHTML = this.renderPreviewScreen();
        this.wirePreviewEvents();
        break;
      case "loading":
        content.innerHTML = this.renderLoadingScreen();
        this.wireLoadingBg();
        break;
      case "result":
        content.innerHTML = this.renderResultScreen();
        this.wireResultEvents();
        break;
      case "history":
        content.innerHTML = this.renderHistoryScreen();
        this.wireHistoryEvents();
        break;
    }
  }

  /**
   * Shows a dedicated upload-in-progress loader (cloud upload animation).
   * Different from the try-on loading screen.
   */
  showUploadLoader(): void {
    const content = this.modal?.querySelector(".snapstyle-modal-content");
    if (!content) return;
    content.innerHTML = this.renderUploadLoadingScreen();
  }

  /* ───────────────────────────────
     Data Setters (called by orchestrator)
     ─────────────────────────────── */

  setPreviewImage(dataUrl: string): void {
    this.previewImageUrl = dataUrl;
  }

  setOriginalPhotoUrl(url: string): void {
    this.originalPhotoUrl = url;
    // Preload original image early so it's ready when compare tab is opened
    if (url) {
      const preload = new Image();
      preload.src = url;
    }
  }

  setResultImage(url: string, isCurrent = false): void {
    this.resultImageUrl = url;
    this.isCurrentTryOn = isCurrent;
    // Default to the tryon tab whenever a fresh result is set
    this.activeTab = "tryon";
  }

  setTryOnHistory(items: TryOnHistoryItem[]): void {
    this.tryOnHistory = items;
  }

  updateProgress(percent: number): void {
    const bar = this.modal?.querySelector(".snapstyle-progress-bar") as HTMLElement | null;
    const text = this.modal?.querySelector(".snapstyle-progress-text");
    if (bar) bar.style.width = `${percent}%`;
    if (text) text.textContent = `${Math.round(percent)}%`;
  }

  /* ───────────────────────────────
     UPLOAD SCREEN
     ─────────────────────────────── */

  private renderUploadScreen(): string {
    const instructions = this.getUploadInstructions();

    const historyPreview = this.tryOnHistory.length > 0
      ? `<div class="snapstyle-history-grid">
          ${this.tryOnHistory.slice(0, 6).map((item, i) => `
            <div class="snapstyle-history-item${i >= 4 ? ' snapstyle-history-item--desktop-only' : ''}" data-result-url="${escapeHtml(item.resultUrl)}" data-original-url="${escapeHtml(item.originalPhotoUrl)}">
              <img src="${escapeHtml(item.resultUrl)}" alt="${escapeHtml(item.productTitle)}" onerror="this.style.display='none'" />
            </div>
          `).join("")}
        </div>
        <button class="snapstyle-btn-viewall">View all history →</button>`
      : `<div class="snapstyle-history-empty">
          <div class="snapstyle-history-empty-icon">${ICONS.historyEmpty}</div>
          <p class="snapstyle-history-empty-text">Start exploring products and try them on virtually to see your history here.</p>
        </div>`;

    const hasInstructions =
      instructions.category !== "default" &&
      Array.isArray(instructions.tips) &&
      instructions.tips.length > 0;

    const instructionsHtml = hasInstructions
      ? `
      <div class="snapstyle-upload-instructions">
        <div class="snapstyle-instructions-header">
          <span class="snapstyle-instructions-icon">${ICONS.info}</span>
          <p class="snapstyle-instructions-heading">${escapeHtml(instructions.instructionsHeading)}</p>
        </div>
        <ul class="snapstyle-instructions-list">
          ${instructions.tips.map((tip) => `
            <li class="snapstyle-instructions-item">
              <span class="snapstyle-instructions-bullet">${ICONS.check}</span>
              <span class="snapstyle-instructions-text">${escapeHtml(tip)}</span>
            </li>
          `).join("")}
        </ul>
      </div>
    `
      : "";

    return `
      <button class="snapstyle-close-btn">${ICONS.close}</button>
      <div class="snapstyle-screen snapstyle-upload-screen">
        <div class="snapstyle-upload-header">
          <h2 class="snapstyle-upload-title">${escapeHtml(instructions.title)}</h2>
          <p class="snapstyle-upload-subtitle">${instructions.subtitle}</p>
        </div>
        <div class="snapstyle-upload-columns">
          <div class="snapstyle-upload-left">
            <div class="snapstyle-upload-area">
              <div class="snapstyle-upload-icon">${ICONS.upload}</div>
              <p class="snapstyle-upload-label">${escapeHtml(instructions.uploadLabel)}</p>
              <p class="snapstyle-upload-hint">${escapeHtml(instructions.uploadHint)}</p>
              <button class="snapstyle-btn-browse"><span class="snapstyle-btn-browse-mobile">${ICONS.gallery} Browse gallery</span><span class="snapstyle-btn-browse-desktop">${ICONS.gallery} Browse my computer</span></button>
            </div>
            <button class="snapstyle-btn-camera">${ICONS.camera} Take photo</button>
            ${instructionsHtml}
          </div>
          <div class="snapstyle-upload-right">
            <div class="snapstyle-history-section">
              <h3 class="snapstyle-history-title">Your Try-On History</h3>
              ${historyPreview}
            </div>
          </div>
        </div>
        <div class="snapstyle-footer">
          <img src="${logoUrl}" alt="Powered by SnapStyle" class="snapstyle-footer-logo-mobile" />
          <img src="${logoUrlDesktop}" alt="Powered by SnapStyle" class="snapstyle-footer-logo-desktop" />
        </div>
      </div>
      <input type="file" class="snapstyle-hidden-input" id="snapstyle-gallery-input" accept="image/jpeg,image/png,image/webp,image/heic,image/heif,.heic,.heif" />
      <input type="file" class="snapstyle-hidden-input" id="snapstyle-camera-input" accept="image/jpeg,image/png,image/webp,image/heic,image/heif,.heic,.heif" capture="user" />
    `;
  }

  private wireUploadEvents(): void {
    if (!this.modal || !this.handlers) return;
    const h = this.handlers;

    this.modal.querySelector(".snapstyle-close-btn")?.addEventListener("click", () => h.onClose());
    this.modal.querySelector(".snapstyle-btn-browse")?.addEventListener("click", () => h.onBrowseGallery());
    this.modal.querySelector(".snapstyle-btn-camera")?.addEventListener("click", () => h.onTakePhoto());
    this.modal.querySelector(".snapstyle-btn-viewall")?.addEventListener("click", () => h.onViewAllHistory());

    // History item clicks
    this.modal.querySelectorAll(".snapstyle-history-item").forEach((item) => {
      item.addEventListener("click", () => {
        const resultUrl = item.getAttribute("data-result-url") || "";
        const originalUrl = item.getAttribute("data-original-url") || "";
        h.onHistoryItemClick(resultUrl, originalUrl);
      });
    });
  }

  /* ───────────────────────────────
     PREVIEW SCREEN
     ─────────────────────────────── */

  private renderPreviewScreen(): string {
    return `
      <button class="snapstyle-close-btn">${ICONS.close}</button>
      <div class="snapstyle-screen snapstyle-preview-screen">
        <div class="snapstyle-preview-image-container">
          <img src="${escapeHtml(this.previewImageUrl)}" alt="Selected photo" onerror="this.alt='Image failed to load'" />
        </div>
        <div class="snapstyle-preview-actions">
          <button class="snapstyle-btn-choose-another">Choose another</button>
          <button class="snapstyle-btn-tryon">Try on</button>
        </div>
        <div class="snapstyle-footer">
          <img src="${logoUrl}" alt="Powered by SnapStyle" class="snapstyle-footer-logo-mobile" />
          <img src="${logoUrlDesktop}" alt="Powered by SnapStyle" class="snapstyle-footer-logo-desktop" />
        </div>
      </div>
    `;
  }

  private wirePreviewEvents(): void {
    if (!this.modal || !this.handlers) return;
    const h = this.handlers;

    this.modal.querySelector(".snapstyle-close-btn")?.addEventListener("click", () => h.onClose());
    this.modal.querySelector(".snapstyle-btn-choose-another")?.addEventListener("click", () => h.onChooseAnother());
    this.modal.querySelector(".snapstyle-btn-tryon")?.addEventListener("click", () => h.onTryOn());
  }

  /* ───────────────────────────────
     HISTORY SCREEN
     ─────────────────────────────── */

  private renderHistoryScreen(): string {
    const gridHtml = this.tryOnHistory.map((item) => `
      <div class="snapstyle-history-full-item" data-result-url="${escapeHtml(item.resultUrl)}" data-original-url="${escapeHtml(item.originalPhotoUrl)}">
        <img src="${escapeHtml(item.resultUrl)}" alt="${escapeHtml(item.productTitle)}" onerror="this.style.display='none'" />
      </div>
    `).join("");

    return `
      <button class="snapstyle-back-btn" aria-label="Go back">${ICONS.back}</button>
      <button class="snapstyle-close-btn">${ICONS.close}</button>
      <div class="snapstyle-screen snapstyle-history-screen">
        <div class="snapstyle-history-header">
          <h2 class="snapstyle-history-screen-title">TRY-ON HISTORY</h2>
          <p class="snapstyle-history-screen-subtitle">Your past try-ons, keep track of what you've explored.</p>
        </div>
        <div class="snapstyle-history-full-grid">
          ${gridHtml || '<p class="snapstyle-history-empty-text">No try-on history yet.</p>'}
        </div>
        <div class="snapstyle-history-actions">
          <button class="snapstyle-btn-goback">Go back</button>
        </div>
        <div class="snapstyle-footer">
          <img src="${logoUrl}" alt="Powered by SnapStyle" class="snapstyle-footer-logo-mobile" />
          <img src="${logoUrlDesktop}" alt="Powered by SnapStyle" class="snapstyle-footer-logo-desktop" />
        </div>
      </div>
    `;
  }

  private wireHistoryEvents(): void {
    if (!this.modal || !this.handlers) return;
    const h = this.handlers;

    this.modal.querySelector(".snapstyle-close-btn")?.addEventListener("click", () => h.onClose());
    this.modal.querySelector(".snapstyle-back-btn")?.addEventListener("click", () => {
      this.showScreen("upload");
    });
    this.modal.querySelector(".snapstyle-btn-goback")?.addEventListener("click", () => {
      this.showScreen("upload");
    });

    this.modal.querySelectorAll(".snapstyle-history-full-item").forEach((item) => {
      item.addEventListener("click", () => {
        const resultUrl = item.getAttribute("data-result-url") || "";
        const originalUrl = item.getAttribute("data-original-url") || "";
        h.onHistoryItemClick(resultUrl, originalUrl);
      });
    });
  }

  /* ───────────────────────────────
     LOADING SCREEN
     ─────────────────────────────── */

  private renderUploadLoadingScreen(): string {
    return `
      <div class="snapstyle-screen snapstyle-upload-loading-screen">
        <div class="snapstyle-upload-loading-overlay">
          <div class="snapstyle-upload-loading-card">
            <div class="snapstyle-upload-cloud-anim">
              <svg class="snapstyle-cloud-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" fill="none">
                <circle class="snapstyle-cloud-ring snapstyle-cloud-ring-1" cx="32" cy="32" r="28" stroke="#D0B8FF" stroke-width="1.5" stroke-dasharray="4 6" />
                <circle class="snapstyle-cloud-ring snapstyle-cloud-ring-2" cx="32" cy="32" r="20" stroke="#C0A0FF" stroke-width="1.5" stroke-dasharray="4 6" />
                <path d="M22 38.5h2.5a6.5 6.5 0 1 1 0-13 7 7 0 0 1 13.5 2A5 5 0 1 1 42 38.5H40" stroke="#863AFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path class="snapstyle-cloud-arrow" d="M32 42v-10M28.5 35.5L32 32l3.5 3.5" stroke="#863AFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <div class="snapstyle-upload-dots">
                <span></span><span></span><span></span>
              </div>
            </div>
            <p class="snapstyle-upload-loading-title">Uploading photo…</p>
            <p class="snapstyle-upload-loading-subtitle">Please wait while we securely upload your image</p>
          </div>
        </div>
      </div>
    `;
  }

  private renderLoadingScreen(): string {
    return `
      <div class="snapstyle-screen snapstyle-loading-screen">
        <div class="snapstyle-loading-bg" id="snapstyle-loading-bg"></div>
        <div class="snapstyle-loading-overlay">
          <div class="snapstyle-loading-card">
            <div class="snapstyle-ai-loader">
              <div class="snapstyle-ai-loader-icon">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="44" height="44">
                  <path d="M9 2L10.09 6.26L14 7L10.09 7.74L9 12L7.91 7.74L4 7L7.91 6.26L9 2ZM16 9L16.73 11.27L19 12L16.73 12.73L16 15L15.27 12.73L13 12L15.27 11.27L16 9ZM7 16L7.54 17.46L9 18L7.54 18.54L7 20L6.46 18.54L5 18L6.46 17.46L7 16Z" fill="#863AFF"/>
                </svg>
              </div>
              <div class="snapstyle-shimmer-bars">
                <div class="snapstyle-shimmer-bar snapstyle-shimmer-bar--lg"></div>
                <div class="snapstyle-shimmer-bar snapstyle-shimmer-bar--md"></div>
                <div class="snapstyle-shimmer-bar snapstyle-shimmer-bar--sm"></div>
              </div>
            </div>
            <div class="snapstyle-progress-container">
              <div class="snapstyle-progress-bar" style="width: 0%"></div>
            </div>
            <p class="snapstyle-progress-text">0%</p>
            <p class="snapstyle-progress-label">Applying virtual try-on</p>
          </div>
        </div>
      </div>
    `;
  }

  private wireLoadingBg(): void {
    const bgImage = this.previewImageUrl || this.originalPhotoUrl;
    if (!bgImage) return;
    const bgEl = this.modal?.querySelector("#snapstyle-loading-bg") as HTMLElement | null;
    if (bgEl) {
      bgEl.style.backgroundImage = `url('${bgImage}')`;
    }
  }

  /* ───────────────────────────────
     RESULT SCREEN
     ─────────────────────────────── */

  private renderResultScreen(): string {
    const compareActive = this.activeTab === "compare" ? "active" : "";
    const tryonActive = this.activeTab === "tryon" ? "active" : "";

    const viewHtml = this.activeTab === "compare"
      ? this.renderCompareView()
      : this.renderTryOnView();

    const thumbsHtml = this.tryOnHistory.map((item) => {
      const isActive = item.resultUrl === this.resultImageUrl ? "active" : "";
      return `<div class="snapstyle-thumb-item ${isActive}" data-result-url="${escapeHtml(item.resultUrl)}" data-original-url="${escapeHtml(item.originalPhotoUrl)}">
        <img src="${escapeHtml(item.resultUrl)}" alt="${escapeHtml(item.productTitle)}" onerror="this.style.display='none'" />
      </div>`;
    }).join("");

    return `
      <button class="snapstyle-back-btn" aria-label="Go back">${ICONS.back}</button>
      <button class="snapstyle-close-btn">${ICONS.close}</button>
      <div class="snapstyle-screen snapstyle-result-screen">
        <div class="snapstyle-tabs">
          <button class="snapstyle-tab ${tryonActive}" data-tab="tryon">Your Try-on</button>
          <button class="snapstyle-tab ${compareActive}" data-tab="compare">Compare</button>
        </div>
        <div class="snapstyle-result-content">
          <div class="snapstyle-result-image-area">
            ${viewHtml}
          </div>
          <div class="snapstyle-result-bottom">
            ${thumbsHtml ? `
            <div class="snapstyle-thumb-wrapper">
              <button class="snapstyle-thumb-arrow snapstyle-thumb-prev" aria-label="Previous">&#8249;</button>
              <div class="snapstyle-thumb-strip">${thumbsHtml}</div>
              <button class="snapstyle-thumb-arrow snapstyle-thumb-next" aria-label="Next">&#8250;</button>
            </div>` : ""}
            <div class="snapstyle-result-actions">
              <button class="snapstyle-btn-retry">${ICONS.retry} Retry</button>
              ${this.isCurrentTryOn ? `<button class="snapstyle-btn-addcart">${ICONS.cart} Add to cart</button>` : ""}
            </div>
          </div>
        </div>
        <div class="snapstyle-footer">
          <img src="${logoUrl}" alt="Powered by SnapStyle" class="snapstyle-footer-logo-mobile" />
          <img src="${logoUrlDesktop}" alt="Powered by SnapStyle" class="snapstyle-footer-logo-desktop" />
        </div>
      </div>
    `;
  }

  private renderCompareView(): string {
    const pos = this.sliderPosition;
    return `
      <div class="snapstyle-compare-container" id="snapstyle-compare">
        <img src="${escapeHtml(this.resultImageUrl)}" alt="Try-on result" class="snapstyle-compare-result" onerror="this.alt='Image failed to load'" />
        <div class="snapstyle-compare-original" style="width: ${pos}%">
          <img src="${escapeHtml(this.originalPhotoUrl)}" alt="Original photo" onerror="this.alt='Image failed to load'" />
        </div>
        <div class="snapstyle-compare-line" style="left: ${pos}%"></div>
        <div class="snapstyle-compare-handle" style="left: ${pos}%">${ICONS.slider}</div>
      </div>
    `;
  }

  private renderTryOnView(): string {
    return `
      <div class="snapstyle-tryon-full">
        <img src="${escapeHtml(this.resultImageUrl)}" alt="Try-on result" onerror="this.alt='Image failed to load'" />
      </div>
    `;
  }

  private wireResultEvents(): void {
    if (!this.modal || !this.handlers) return;
    const h = this.handlers;

    this.modal.querySelector(".snapstyle-close-btn")?.addEventListener("click", () => h.onClose());
    this.modal.querySelector(".snapstyle-back-btn")?.addEventListener("click", () => {
      this.showScreen("upload");
    });
    this.modal.querySelector(".snapstyle-btn-retry")?.addEventListener("click", () => h.onRetry());
    this.modal.querySelector(".snapstyle-btn-addcart")?.addEventListener("click", () => h.onAddToCart());

    // Tabs
    this.modal.querySelectorAll(".snapstyle-tab").forEach((tab) => {
      tab.addEventListener("click", () => {
        this.activeTab = (tab.getAttribute("data-tab") as ResultTab) || "compare";
        this.showScreen("result");
      });
    });

    // Thumbnail clicks
    this.modal.querySelectorAll(".snapstyle-thumb-item").forEach((thumb) => {
      thumb.addEventListener("click", () => {
        const resultUrl = thumb.getAttribute("data-result-url") || "";
        const originalUrl = thumb.getAttribute("data-original-url") || "";
        this.resultImageUrl = resultUrl;
        this.originalPhotoUrl = originalUrl;
        this.isCurrentTryOn = false;
        this.showScreen("result");
      });
    });

    // Thumb strip scroll arrows
    const strip = this.modal.querySelector(".snapstyle-thumb-strip") as HTMLElement | null;
    const prevBtn = this.modal.querySelector(".snapstyle-thumb-prev") as HTMLElement | null;
    const nextBtn = this.modal.querySelector(".snapstyle-thumb-next") as HTMLElement | null;

    if (strip && prevBtn && nextBtn) {
      const SCROLL_AMOUNT = 82; // thumb width (64) + gap (18)

      const updateArrows = () => {
        prevBtn.style.opacity = strip.scrollLeft <= 0 ? "0.3" : "1";
        prevBtn.style.pointerEvents = strip.scrollLeft <= 0 ? "none" : "auto";
        const atEnd = strip.scrollLeft >= strip.scrollWidth - strip.clientWidth - 2;
        nextBtn.style.opacity = atEnd ? "0.3" : "1";
        nextBtn.style.pointerEvents = atEnd ? "none" : "auto";
      };

      prevBtn.addEventListener("click", () => {
        strip.scrollBy({ left: -SCROLL_AMOUNT, behavior: "smooth" });
      });
      nextBtn.addEventListener("click", () => {
        strip.scrollBy({ left: SCROLL_AMOUNT, behavior: "smooth" });
      });
      strip.addEventListener("scroll", updateArrows);
      updateArrows(); // set initial state
    }

    // Compare slider drag
    this.initCompareSlider();
  }

  private initCompareSlider(): void {
    const container = this.modal?.querySelector("#snapstyle-compare") as HTMLElement | null;
    if (!container) return;

    const handle = container.querySelector(".snapstyle-compare-handle") as HTMLElement;
    const line = container.querySelector(".snapstyle-compare-line") as HTMLElement;
    const original = container.querySelector(".snapstyle-compare-original") as HTMLElement;
    const resultImg = container.querySelector(".snapstyle-compare-result") as HTMLImageElement;
    const originalImg = original?.querySelector("img") as HTMLImageElement;

    if (!handle || !line || !original || !resultImg || !originalImg) return;

    let maxSliderPercent = 100;

    // After images load, calculate the max slider position
    const initializeSliderConstraints = () => {
      if (!resultImg.complete || !originalImg.complete ||
        resultImg.naturalWidth === 0 || originalImg.naturalWidth === 0) return;

      const containerWidth = container.offsetWidth;

      // The original image renders at height:100% / width:auto via CSS.
      // Read its actual rendered width to know where the slider should stop.
      const originalRenderedWidth = originalImg.offsetWidth;

      // If the original image is wider than the container, center it horizontally
      if (originalRenderedWidth > containerWidth) {
        const offset = (originalRenderedWidth - containerWidth) / 2;
        originalImg.style.left = `-${offset}px`;
      }

      // maxSliderPercent: if original is narrower than container, cap the slider
      maxSliderPercent = Math.min(100, (originalRenderedWidth / containerWidth) * 100);

      // Set initial slider position
      const initialPos = Math.min(50, maxSliderPercent);
      this.sliderPosition = initialPos;

      handle.style.left = `${initialPos}%`;
      line.style.left = `${initialPos}%`;
      original.style.width = `${initialPos}%`;
    };

    // Wait for both images to load
    const checkImagesLoaded = () => {
      if (resultImg.complete && originalImg.complete) {
        setTimeout(() => initializeSliderConstraints(), 100);
      } else {
        Promise.all([
          new Promise((resolve) => {
            if (resultImg.complete) resolve(null);
            else resultImg.onload = () => resolve(null);
          }),
          new Promise((resolve) => {
            if (originalImg.complete) resolve(null);
            else originalImg.onload = () => resolve(null);
          })
        ]).then(() => setTimeout(() => initializeSliderConstraints(), 100));
      }
    };
    checkImagesLoaded();

    // Move the slider — simple percentage of container width
    const updateSlider = (clientX: number) => {
      const rect = container.getBoundingClientRect();
      let pos = ((clientX - rect.left) / rect.width) * 100;
      pos = Math.max(0, Math.min(maxSliderPercent, pos));
      this.sliderPosition = pos;

      handle.style.left = `${pos}%`;
      line.style.left = `${pos}%`;
      original.style.width = `${pos}%`;
    };

    // Mouse events
    const onMouseMove = (e: MouseEvent) => {
      if (this.isDragging) {
        e.preventDefault();
        updateSlider(e.clientX);
      }
    };
    const onMouseUp = () => {
      this.isDragging = false;
      document.removeEventListener("mousemove", onMouseMove);
      document.removeEventListener("mouseup", onMouseUp);
    };

    handle.addEventListener("mousedown", (e) => {
      e.preventDefault();
      this.isDragging = true;
      document.addEventListener("mousemove", onMouseMove);
      document.addEventListener("mouseup", onMouseUp);
    });

    // Touch events
    handle.addEventListener("touchstart", (e) => {
      e.preventDefault();
      this.isDragging = true;
    });
    container.addEventListener("touchmove", (e) => {
      if (this.isDragging && e.touches[0]) {
        updateSlider(e.touches[0].clientX);
      }
    });
    container.addEventListener("touchend", () => {
      this.isDragging = false;
    });

    // Click on container to jump slider
    container.addEventListener("click", (e) => {
      updateSlider(e.clientX);
    });

    // Cleanup
    this.cleanupFunctions.push(() => {
      document.removeEventListener("mousemove", onMouseMove);
      document.removeEventListener("mouseup", onMouseUp);
    });
  }
}
